export default {
  title: 'SMS reports',
  tableHeaderActionTooltip: 'Create new sms report',
  dialog: {
    title: {
      generateReport: 'Generate sms report',
      deleteReport: 'Delete sms report',
      cancelReport: 'Cancel sms report',
      regenerateReport: 'Regenerate sms report',
      retryReport: 'Retry sms report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate sms report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter sms report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    statuses: {
      label: 'Statuses',
      placeholder: 'Select statuses'
    },
    operators: {
      label: 'Operator',
      placeholder: 'Select operators'
    },
    operationIds: {
      label: 'Operation Ids',
      placeholder: 'Select operation Ids'
    },
    recipientMsisdns: {
      label: 'Recipient phone number(s)',
      placeholder: 'Select Recipient phone number(s)'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    statuses: {
      label: 'Status(es)'
    },
    operators: {
      label: 'Operator(s)'
    },
    operationIds: {
      label: 'Operation Id(s)'
    },
    recipientMsisdns: {
      label: 'Recipient phone number(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
